export default __webpack_public_path__ + "static/media/twitter.6f023e06.svg";